import { request } from 'umi';

export async function getRoleAll(params?: API.RoleGetParamtersType) {
  return request<API.PageDataType<API.Role>>('/role/all', {
    method: 'get',
    params,
  });
}
